<header class="header-component d-flex align-item-center justify-space-between">
  @if( !isSidebarOpen ){
  <div class="d-flex flex-row justify-center" style="width: 100px;" hideLTLarge>
    <img class=" sidebar-logo" id="go-home" [src]="configurationStyles.TLOG" (click)="goHome()" @fadeIn>
  </div>

  }@else{
  <img class="sidebar-logo" hideLTLarge id="go-home" [src]="configurationStyles.SLOG" (click)="goHome()"
    @fadeIn
    [ngClass]="{'p-r-30 p-l-30': currentScreen === 'Web' || currentScreen === 'Tablet', 'p-r-20 p-l-20': currentScreen === 'Handset'}">
  }

  <img class="p-l-30 sidebar-logo-desktop" hideLarge id="go-home" [src]="configurationStyles.SLOG"
    (click)="goHome()"
    [ngClass]="{'p-r-30 p-l-30': currentScreen === 'Tablet', 'p-r-20 p-l-20': currentScreen === 'Handset'}">



  <div class="panel-menu d-flex align-item-center  justify-center"
    [ngClass]="{'p-r-30 p-l-30': currentScreen === 'Tablet', 'p-r-20 p-l-20': currentScreen === 'Handset'}">

    <fa-icon [icon]="['fal','user']" class="font-16 icon-border cursor-pointer icon-w-h m-r-30 menu-desktop"
      [matMenuTriggerFor]="menu" id="trigger-menu"></fa-icon>

    <mat-menu #menu="matMenu" class="panel-multi-select">
      <div class="p-t-6">
        <p class="user m-0 p-b-5 p-l-20 p-r-20" id="menu-user-name">{{ fistName | titlecase }} {{ lastName | titlecase
          }}</p>
        <p class="m-0 p-r-20 p-l-20 p-b-14 speciality-text" id="menu-speciality-user">{{ speciality | capitalize }}</p>
      </div>

      <div style="border-bottom: 0.5px solid #E7E7EA"></div>

      <ul class="p-0 m-0 remove-style-list">
        <li class="d-flex justify-space-between p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14" (click)="openProfile()">
          <div class="align-item-center">
            <fa-icon [icon]="['fal','user']" class="font-16 m-r-15 " [fixedWidth]="true"></fa-icon>
            <span class="m-0 font-14 item-menu" id="text-item-fee">{{ 'configuration-page.action-dialog.my-profile' | translate }}</span>
          </div>
        </li>

        <li class="d-flex justify-space-between p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14"
          (click)="helpOptions(); $event.stopPropagation();" id="help-expand">
          <div class="align-item-center">
            <fa-icon [icon]="['fal','circle-question']" class="m-r-15"></fa-icon>
            <span class="m-0 font-14 item-menu " id="text-item-help">{{ 'common-page.footer.help' |
              translate }}</span>
          </div>
          <div class="align-item-center">
            @if( !isHelpOpen ){
            <fa-icon [icon]="['fal','angle-down']"></fa-icon>
            }@else {
            <fa-icon [icon]="['fal','angle-up']"></fa-icon>
            }

          </div>

        </li>

        @if( isHelpOpen ){
        <li class="d-flex justify-space-between p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14" id="open-help"
          (click)="openHelp()">
          <div @fadeIn>
            <fa-icon [icon]="['fal','circle-question']" class="v-hidden p-r-10"></fa-icon>
            <span class="m-0 font-14 item-menu  p-r-20" id="text-item-help">{{ 'help-modal.help.title' |
              translate }}</span>
          </div>
        </li>

        <li class="d-flex justify-space-between p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14" id="open-manual"
          [routerLink]="['/help/user-manual']">
          <div @fadeIn>
            <fa-icon [icon]="['fal','circle-question']" class="v-hidden p-r-10"></fa-icon>
            <span class="m-0 font-14 item-menu  p-r-20" id="user-manual-item">
              {{ 'common-page.sidebar.user-manual'| translate }}</span>
          </div>
        </li>

        }

        <li class="d-flex align-item-center p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14" id="item-menu-logout"
          (click)="redirect('login')">
          <fa-icon [icon]="['fal','arrow-right-from-bracket']" class="m-r-15"></fa-icon>
          <p class="m-0 font-14 item-menu " id="logout">{{
            'common-page.navbar-user-menu.logout' | translate }}</p>
        </li>
      </ul>

    </mat-menu>
    <div class=" menu-toogle-mobile">
      @if(!isMenuOpen){
      <fa-icon [icon]="['fal','bars']" style="
        color: #2B2E34;" [fixedWidth]="false" class="font-14 " #menuToogle (click)="openMenu($event)"
        id="trigger-menu"></fa-icon>
      }@else {
      <fa-icon [icon]="['fal','xmark']" style="
          color: #2B2E34;
      " [fixedWidth]="false" id="close-menu" class="font-14" #menuToogle (click)="openMenu($event)"></fa-icon>
      }

    </div>
  </div>

</header>

@if( isMenuOpen ){
<div class="menu-mobile" #menuMobile>
  <div class="w-100 m-l-20 m-r-20 m-t-30 p-b-30 d-flex flex-row justify-start gap-10"
    style="border-bottom: 0.5px solid  #E7E7EA">
    <div class="m-r-10 user-icon">
      <fa-icon [icon]="['fal','user']" class="font-16  cursor-pointer" [fixedWidth]="false"></fa-icon>

    </div>
    <div class="p-t-3">
      <p class="user m-0" id="menu-user-name">{{ fistName | titlecase }} {{ lastName | titlecase }}</p>
      <p class="m-0 speciality-text" id="menu-speciality-user">{{ speciality | capitalize }}</p>
    </div>
  </div>
  <ul class="p-0 remove-style-list">

    <li *appShowHavePermission="'home'" routerLinkActive="active" class="item-sidebar d-flex align-item-center"
      id="item-menu-home" [routerLink]="['/home']">
      <div class="d-flex flex-row justify-start align-item-center m-l-20 m-r-20 p-t-14 p-b-14">
        <fa-icon [icon]="['fal','house']" class="font-16 m-r-15 " [fixedWidth]="true"></fa-icon>
        <p class="m-0 font-14" id="text-item-home">{{ 'common-page.sidebar.home' | translate }}</p>
      </div>
    </li>

    <li *appShowHavePermission="'fees'" class="item-sidebar d-flex flex-column " id="item-menu-fee"
      [routerLink]="['/fee']" routerLinkActive="active">
      <div class="d-flex flex-row justify-start align-item-center m-l-20 m-r-20 p-t-14 p-b-14">
        <fa-icon [icon]="['fal','file-waveform']" class="font-16 m-r-15 " [fixedWidth]="true"></fa-icon>
        <p class="m-0 font-14  " id="text-item-fee">{{ 'login-page.login-form.fee' | translate }}</p>
      </div>
    </li>

    <li class="item-sidebar d-flex flex-column " id="item-menu-profile" (click)="openProfile()">
      <div class="d-flex flex-row justify-start align-item-center m-l-20 m-r-20 p-t-14 p-b-14">
        <fa-icon [icon]="['fal','user']" class="font-16 m-r-15 " [fixedWidth]="true"></fa-icon>
        <p class="m-0 font-14  " id="text-item-fee">{{ 'configuration-page.action-dialog.my-profile' | translate }}</p>
      </div>
    </li>

    <!-- START MENU CONFIGURATION-->
    <li *appShowHavePermission="'userManagement'" class="item-sidebar d-flex align-item-center"
      id="item-menu-configuration" (click)="changeMenus('configuration')">
      <div class="d-flex flex-row justify-space-between align-item-center m-l-20 m-r-20 p-t-14 p-b-14 w-100">
        <div class="d-flex flex-row align-item-center justify-start">
          <fa-icon [icon]="['fal','gear']" class="font-16 m-r-15 color-text" [fixedWidth]="true"></fa-icon>
          <p class="m-0 font-14  color-text" id="text-item-help">{{ 'common-page.sidebar.configuration' | translate }}
          </p>

        </div>

        @if( !menuConfiguration ){
        <fa-icon [icon]="['fal','angle-down']" class="font-16 color-text " [fixedWidth]="true"
          (click)="changeMenus('configuration');$event.stopPropagation();" @fadeIn></fa-icon>
        }@else {
        <fa-icon [icon]="['fal','angle-up']" class="font-16 color-text" [fixedWidth]="true"
          (click)="changeMenus('configuration');$event.stopPropagation();" @fadeIn></fa-icon>
        }
      </div>
    </li>

    @if( menuConfiguration ){
    <li class="d-flex justify-space-between p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14" id="open-configuration" @fadeIn
      [routerLink]="['/configuration/profile']">
      <div>
        <fa-icon [icon]="['fal','gear']" class="v-hidden font-16 m-r-15 color-text"></fa-icon>
        <span class="m-0 font-14 item-menu  p-r-20 color-text" id="text-item-user">
          {{ 'common-page.sidebar.users' | translate }}
        </span>
      </div>
    </li>
    }

    <!-- START MENU HELP-->
    <li *appShowHavePermission="'help'" class="item-sidebar d-flex align-item-center" id="item-menu-help"
      (click)="changeMenuHelp()">
      <div class="d-flex flex-row justify-space-between align-item-center m-l-20 m-r-20 p-t-14 p-b-14 w-100">
        <div class="d-flex flex-row align-item-center justify-start">
          <fa-icon [icon]="['fal','circle-question']" class="font-16 m-r-15 color-text" [fixedWidth]="true"></fa-icon>
          <p class="m-0 font-14  color-text" id="text-item-help">{{ 'common-page.footer.help' | translate }}</p>

        </div>

        @if( !menuHelp ){
        <fa-icon [icon]="['fal','angle-down']" class="font-16 color-text " [fixedWidth]="true"
          (click)="changeMenuHelp();$event.stopPropagation();" @fadeIn></fa-icon>
        }@else {
        <fa-icon [icon]="['fal','angle-up']" class="font-16 color-text" [fixedWidth]="true"
          (click)="changeMenuHelp();$event.stopPropagation();" @fadeIn></fa-icon>
        }
      </div>
    </li>

    @if( menuHelp ){
    <li class="d-flex justify-space-between p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14" id="open-help" @fadeIn
      (click)="openHelp()">
      <div>
        <fa-icon [icon]="['fal','circle-question']" class="v-hidden font-16 m-r-15 color-text"></fa-icon>
        <span class="m-0 font-14 item-menu  p-r-20 color-text" id="text-item-help">{{ 'help-modal.help.title' |
          translate }}</span>
      </div>
    </li>

    <li class="d-flex item-sidebar justify-space-between p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14"
      id="open-user-manual" @fadeIn [routerLink]="['/help/user-manual']" routerLinkActive="active">
      <div>
        <fa-icon [icon]="['fal','circle-question']" class="v-hidden font-16 m-r-15 color-text"></fa-icon>
        <span class="m-0 font-14 item-menu  p-r-20 color-text" id="text-item-help">{{ 'common-page.sidebar.user-manual'|
          translate }}</span>
      </div>
    </li>
    }
    <!-- END MENU HELP-->

    <!-- START MENU COOKIES-->
    <li class="item-sidebar d-flex align-item-center" id="item-menu-help" (click)="changeMenuCookies()">
      <div class="d-flex flex-row justify-space-between align-item-center m-l-20 m-r-20 p-t-14 p-b-14 w-100">
        <div class="d-flex flex-row align-item-center justify-start">
          <fa-icon [icon]="['fal','lock']" class="font-16 m-r-15 color-text" [fixedWidth]="true"></fa-icon>
          <p class="m-0 font-14 color-text" id="common-page.footer.security-privacity">
            {{'common-page.footer.security-privacity' | translate}}</p>

        </div>

        @if( !menuPrivacity ){
        <fa-icon [icon]="['fal','angle-down']" class="font-16 color-text" [fixedWidth]="true"
          (click)="changeMenuCookies();$event.stopPropagation();" @fadeIn></fa-icon>
        }@else {
        <fa-icon [icon]="['fal','angle-up']" class="font-16 color-text" [fixedWidth]="true"
          (click)="changeMenuCookies();$event.stopPropagation();" @fadeIn></fa-icon>
        }
      </div>
    </li>

    @if( menuPrivacity ){
    <li class="d-flex justify-space-between p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14" id="open-privacity"
      (click)="goToLink('https://www.juaneda.es/legal')">
      <div>
        <fa-icon [icon]="['fal','circle-question']" [fixedWidth]="true"
          class="v-hidden font-16 m-r-15 color-text"></fa-icon>
        <span class="m-0 font-14 item-menu  p-r-20 color-text"
          id="common-page.footer.legal-warning ">{{'common-page.footer.legal-warnings' | translate}}</span>
        <!--TODO: LABEL-->
      </div>
    </li>

    <li class="d-flex justify-space-between p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14 color-text" id="open-privacity"
      (click)="goToLink('https://www.juaneda.es/privacy')">
      <div>
        <fa-icon [icon]="['fal','circle-question']" [fixedWidth]="true"
          class="v-hidden font-16 m-r-15 color-text"></fa-icon>
        <span class="m-0 font-14 item-menu  p-r-20 color-text"
          id="common-page.footer.privacy-policies">{{'common-page.footer.privacy-policies' | translate}}</span>
      </div>
    </li>

    <li class="d-flex justify-space-between p-r-20 p-l-20 cursor-pointer p-t-14 p-b-14" id="open-privacity"
      (click)="openCookies()">
      <div>
        <fa-icon [icon]="['fal','circle-question']" [fixedWidth]="true"
          class="v-hidden font-16 m-r-15 color-text"></fa-icon>
        <span class="m-0 font-14 item-menu  p-r-20 color-text"
          id="common-page.footer.cookies-policies">{{'common-page.footer.cookies-policies' | translate}}</span>
      </div>
    </li>

    }
    <!-- END MENU COOKIES-->


    <li class="item-sidebar d-flex flex-column  p-t-15" id="item-menu-logout" style="border-top: 1px solid #E7E7EA"
      (click)="redirect('login')">
      <div class="d-flex flex-row justify-start align-item-center m-l-20 m-r-20 p-t-14 p-b-14">

        <fa-icon [icon]="['fal','arrow-right-from-bracket']" class="font-16 m-r-15 color-text"></fa-icon>
        <p class="m-0 font-14 color-text " id="logout">
          {{ 'common-page.navbar-user-menu.logout' | translate }}</p>
      </div>
    </li>

  </ul>
  <div class="footer">
    <p id="footer">{{'common-page.footer.copyright'| translate}}</p>
  </div>
</div>
}
